import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Card, DatePicker, Space, Table, Tag, Typography, Row, Col, Statistic } from 'antd';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { api } from '@/lib/api';
import { formatRupiah } from '@/lib/format';
const TYPE_COLOR = {
    ASSET: 'blue',
    LIABILITY: 'gold',
    NET_ASSET: 'purple',
    REVENUE: 'green',
    EXPENSE: 'volcano',
};
export function TrialBalancePage() {
    const [period, setPeriod] = useState(dayjs());
    const q = useQuery({
        queryKey: ['trial-balance', period.format('YYYY-MM')],
        queryFn: async () => (await api.get('/reports/trial-balance', {
            params: { period: period.format('YYYY-MM') },
        })).data,
    });
    const cols = [
        { title: 'Kode', dataIndex: 'account_code', width: 120 },
        { title: 'Nama Akun', dataIndex: 'account_name' },
        {
            title: 'Kategori',
            dataIndex: 'account_type',
            width: 130,
            render: (t) => _jsx(Tag, { color: TYPE_COLOR[t], children: t }),
        },
        {
            title: 'Debit',
            dataIndex: 'debit',
            width: 160,
            align: 'right',
            render: (v) => _jsx("span", { className: "money", children: formatRupiah(v) }),
        },
        {
            title: 'Kredit',
            dataIndex: 'credit',
            width: 160,
            align: 'right',
            render: (v) => _jsx("span", { className: "money", children: formatRupiah(v) }),
        },
        {
            title: 'Saldo',
            dataIndex: 'balance',
            width: 170,
            align: 'right',
            render: (v) => _jsx("span", { className: "money", children: _jsx("b", { children: formatRupiah(v) }) }),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Neraca Saldo" }), _jsx(DatePicker.MonthPicker, { value: period, onChange: (v) => setPeriod(v ?? dayjs()) })] }), _jsxs(Row, { gutter: 16, style: { marginBottom: 16 }, children: [_jsx(Col, { span: 8, children: _jsx(Card, { children: _jsx(Statistic, { title: "Total Debit", value: parseFloat(q.data?.total_debit ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#0F766E' } }) }) }), _jsx(Col, { span: 8, children: _jsx(Card, { children: _jsx(Statistic, { title: "Total Kredit", value: parseFloat(q.data?.total_credit ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#B91C1C' } }) }) }), _jsx(Col, { span: 8, children: _jsx(Card, { children: _jsx(Statistic, { title: "Status", value: q.data && q.data.total_debit === q.data.total_credit
                                    ? 'BALANCE'
                                    : 'TIDAK BALANCE', valueStyle: {
                                    color: q.data && q.data.total_debit === q.data.total_credit ? '#059669' : '#DC2626',
                                } }) }) })] }), _jsx(Card, { children: _jsx(Table, { rowKey: "account_id", loading: q.isLoading, dataSource: q.data?.rows ?? [], columns: cols, pagination: false, size: "middle" }) })] }));
}
